import React, {Component} from 'react'
import server from '../../server';
import date from '../../date';
import TelephoneInput from '../../inputs/TelephoneInput';
import CpfInput from '../../inputs/CpfInput';
import EmailInput from '../../inputs/EmailInput';
import CepInput from '../../inputs/CepInput';

class BluesCard extends Component{
    render(){
        let hours = [];
        let allHours = date.range(360,1260, 30);

        allHours.forEach((hour) =>{
            const hourString = date.min_to_Hour(hour);
            hours.push(
                <div className="peer">
                    <button 
                        onClick={() => this.props.activateModal(hourString, true)} 
                        type="button" 
                        class="modal-toogle  btn cur-p btn-outline-primary">{hourString}</button>
                </div>)
        })

        return(
            <div class="col-sm-6 mB-20">
                <div style={{display:"block", textAlign:"center"}} class="schedule-card bdr-20 bdrs-5 bd p-10 ai-c">
                    <img style={{display: "inline-block", transform: "translateY(-40%)", height: 80, width: 80}} class="schedule-image mR-10 mL-10" src="https://randomuser.me/api/portraits/men/10.jpg"
                        alt=""/>
                    <div style={{display: 'inline-block', width: "50%"}} class="client-info p-10 schedule-card-flex-box">
                        <h5 class="c-client-default">
                            <div class="fsz-md mB-10">
                                <b>Deixe com a Blues!</b>
                            </div>
                            <div class="fsz-xs c-client-secondary">Especialidade</div>
                            <span class="fsz-sm">Todas</span>
                            <div class="clearfix"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                        </h5>
                    </div>
                    <div style={{width:"100%"}} class="p-10 schedule-card-flex-box">
                        <div class="w-100 gap-10 peers jc-c">
                            {hours}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class FisioterapistCard extends Component{
    constructor(props){
        super(props);
        this.state = {
            clinicHours:[],
            homeHours:[]
        };
    }

    componentWillMount(){
        this.loadHours()
    }

    loadHours = () =>{
        let clinicHours = [];
        let homeHours = [];
        let allHours = date.range(360,1260, 30);

        const disabledStyle = {color: "#9E9E9E", backgroundColor: "#ECEFF1", borderColor: "lightgray"};

        for(let i = 0; i < 2; i++){
            let currentArray = (i == 0 ? clinicHours : homeHours);
            let checkArray = (i == 0 ? this.props.time.clinic : this.props.time.home);
            let timeInterval = (i == 0 ? this.props.fisioterapist.clinicAppointmentLength : this.props.fisioterapist.homeAppointmentLength)

            if(timeInterval == 0 || timeInterval == null) timeInterval = 30;

            let allHours = date.range(360,1260, timeInterval);

            allHours.forEach((hour) =>{
                const hourString = date.min_to_Hour(hour);
                const disabled = checkArray.indexOf(hourString) == -1;

                currentArray.push(
                    <div className="peer">
                        <button 
                            disabled={disabled}
                            style={disabled ? disabledStyle : {}}
                            onClick={() => this.props.activateModal(hourString, true)} 
                            type="button" 
                            class="modal-toogle  btn cur-p btn-outline-primary">{hourString}</button>
                    </div>
                )
            })
        }

        this.setState({clinicHours:clinicHours, homeHours:homeHours});
    }

    render(){
        
        return(
            <div class="col-sm-6 mB-20">
                <div style={{display:"block", textAlign:"center"}} class="schedule-card bdr-20 bdrs-5 bd p-10 ai-c">
                    <img style={{display: "inline-block", transform: "translateY(-40%)", height: 80, width: 80}} class="schedule-image mR-10 mL-10" src={server.imagePath + "/profile/" + this.props.fisioterapist.profilePicture}
                        alt=""/>
                    <div style={{display: 'inline-block', width: "50%"}} class="client-info p-10 schedule-card-flex-box">
                        <h5 class="c-client-default">
                            <div class="fsz-md mB-10">
                                <b>{this.props.name}</b>
                            </div>
                            <div class="fsz-xs c-client-secondary">Especialidade</div>
                            <span class="fsz-sm">Não Definido</span>
                            <div class="clearfix"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-full"></div>
                            <div class="fa fa-star mR-5 star active-half"></div>
                            <div class="fa fa-star mR-5 star"></div>
                        </h5>
                    </div>
                    <div style={{width:"100%"}} class="p-10 schedule-card-flex-box">
                        <b className="c-client-default fsz-md mB-10">Clínica</b><br/><br/>
                        <div class="gap-10 peers jc-c">
                            {this.state.clinicHours}
                        </div>
                        <br/><br/>
                        <b className="c-client-default fsz-md mB-10">Domiciliar</b><br/><br/>
                        <div class="gap-10 peers jc-c">
                            {this.state.homeHours}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class ClientDetails extends Component{
    state = {
        cep:"",
        doctorId: null,
        credit_card:true
    }

    onChange = (event) =>{
        this.setState({[event.target.id]: event.target.value, [event.target.id + "_error"]: false},() => console.log(this.state));
    }

    fetch_patient = () =>{
        if(this.state.cpf && !this.state.cpf.includes("_")){
            if(!this.state.fetch){
              let cpf = this.state.cpf.replace(/\./g, '').replace(/\-/,'')
              this.setState({fetch:true})
              server.get("users/cpf/" + cpf, (data) =>{
                if(data.id){
                    let newStatus = this.state;
                    Object.keys(data).forEach((key) =>{
                        newStatus[key] = data[key]
                    });
                    this.setState(newStatus);
                }
              })
            }
        }else if(this.state.fetch){
          this.setState({fetch:false,patient:null})
        }
      }

    check = () =>{
        let new_state = {
            cpf_error:false,
            name_error: false,
            email_error: false,
            telephone_error:false,
            doctorId_error:false,
            cep_error: false,
            street_error: false,
            number_error: false,
            neighborhood_error: false
        }

        let failed = false;

        this.setState(new_state)

        if(this.state.locale == 0){
            this.setState({locale_error:true});
            failed = true;
        }

        if(this.state.doctorId == -1 || this.state.doctorId == null){
            this.setState({doctorId_error:true})
            failed = true;
        }

        if(this.state.cpf == null || this.state.cpf.toString().includes("_")){
            this.setState({cpf_error:true})
            failed = true;
        }

        if(this.state.cep == null || this.state.cep.toString().includes("_") || this.state.cep == ""){
            this.setState({cep_error:true})
            failed = true;
        }

        if(this.state.street == "" || this.state.street == null){
            this.setState({street_error: true});
            failed = true;
        }

        if(this.state.city == "" || this.state.city == null){
            this.setState({city_error: true});
            failed = true;
        }

        if(this.state.state == "" || this.state.state == null){
            this.setState({state_error: true});
            failed = true;
        }

        if(this.state.neighborhood == "" || this.state.neighborhood == null){
            this.setState({neighborhood_error: true});
            failed = true;
        }

        if(this.state.number == "" || this.state.number == null){
            this.setState({number_error: true});
            failed = true;
        }

        if(this.state.name == null || this.state.name == ""){
            this.setState({name_error: true})
            failed = true;
        }

        if(this.state.email == null || this.state.email.indexOf("@") == 0){
            this.setState({email_error:true})
            failed = true;
        }

        if(this.state.doctorId == null || this.state.doctorId == -1){
            this.setState({doctorId_error:true})
            failed = true;
        }

        if(this.state.telephone == null || this.state.telephone == "" || this.state.telephone.toString().replace("(","").replace(")","").replace(/_/g,"").length < 10){
            this.setState({telephone_error:true})
            failed = true;
        }

        if(!failed) this.setDate();
        else this.props.alert("Falta Informações!", "Verifique todos os campos", "error");
    }

    setDate = () =>{
        let date = this.props.today;
        let sqlDate = date.getFullYear() + '-' +
              ('00' + date.getDate()).slice(-2) + '-' +
              ('00' + (date.getMonth() + 1)).slice(-2) + ' ' +
              (this.props.currentTime)
        this.setState({"date":sqlDate},() => this.link())
      }
  
    link = () => {
        const appDate = this.props.today.getFullYear() + "-" + (this.props.today.getMonth() + 1) + "-" + this.props.today.getDate() + " " + this.props.currentTime;

        let appointment = this.state

        appointment["price"] = 100;
        appointment["charged"] = false;
        if(server.userType == "secretary")
        appointment["secretaryId"] = server.user.id;
        appointment["doctorId"] = this.state.doctorId;
        appointment["fisioterapistId"] = this.props.currentFisioterapist.id;
        appointment["clinicId"] = server.clinic.id;
        appointment["cpf"] = appointment["cpf"].replace(/\./g, '').replace(/\-/,'');
        if(typeof(appointment["cep"]) == typeof(""))
        appointment["cep"] = appointment["cep"].replace(/\-/g,'');
        if(typeof(appointment["telephone"]) == typeof(""))
        appointment["telephone"] = appointment["telephone"].replace(/\_/,'').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'');
        appointment["evaluation"] = true;
        appointment["clinic"] = this.props.isClinic;
        appointment["dates"] = JSON.stringify([appDate]);
        if(appointment["res_telephone"]){
        appointment["res_telephone"] = appointment["res_telephone"].replace(/\_/, ' ').replace(/\(/g, '').replace(/\)/,'').replace(/\-/,'');
        }

        server.post("appointments", appointment, (data) =>{
        if(data.id){
            this.props.alert("Consulta marcada com sucesso!", "", "success");
            this.props.hide();
        }else{
            this.props.alert("Erro vinculando paciente", "Tente novamente mais tarde...", "error");
        }
        });
    }

    render(){
        if(this.state.cep && typeof(this.state.cep) != typeof(1)){
            let cepNumber = this.state.cep.replace(/\-/,"").replace(/\_/,"")
            if(cepNumber.length == 8){
                if(!this.state.cep_loaded){
                        fetch(server.address + "/cep/" + cepNumber,{
                                method: "GET"
                        }).then(response => response.json().then(data => {
                                this.setState({street:data.endereco,neighborhood:data.bairro,state:data.uf,city:data.cidade,street_error:false,neighborhood_error:false,state_error:false,city_error:false})
                        }))
                        this.setState({cep_loaded:true})
                }
            }else{
                if(this.state.cep_loaded){
                        this.setState({cep_loaded:false})
                }
            }
        }

        this.fetch_patient();

        let day = this.props.today.getDate();
        let month = this.props.today.getMonth() + 1;
        let year = this.props.today.getFullYear();

        if (day < 10) day = "0" + day;
        if (month < 10) month = "0" + month;

        return(
            <div class={"app-modal bgc-white mobile-scroll " + (this.props.active == true ? "active" : "")}>
                <div class="w-100p clinic-data inner-content">
                    <div class="w-100p ai-c jc-sb b-0 bdB pX-20">
                        <h3 class=" mT-10 p-0">Vincular paciente</h3>
                        <button onClick={this.props.hide} type="button" class="modal-toogle btn btn-clear pX-5 pY-0 pos-a t-15 r-0 bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>

                        <div class="clearfix"></div>
                    </div>
                    <div class="scrollable">
                        <div class="content-data peers  ai-c jc-c">
                            <div class="w-100p ta-c mT-20">
                                <div class="fsz-xs c-client-default">Fisioterapeuta</div>
                                <h3 class="ta-c m-0">{this.props.currentFisioterapist == null ? "Deixe com a Blues!" : this.props.currentFisioterapist.name}</h3>


                                <hr class="small bdc-client-default mY-10"/>
                            </div>

                            <div class="p-10 peers ai-c jc-sb  w-100p">
                                <div class="p-10  w-100p bdB ta-c">
                                    <div class="p-0 w-100p">
                                        <label>Data do atendimento</label>
                                    </div>
                                    <div class="form-group pR-10 pL-0   mB-10 w-100p">
                                        <h4 class="m-0">{day + "/" + month + "/" + year + " às " + this.props.currentTime}</h4>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop:10}} class="scrollable h-100p w-100p">

                                <div class="p-0 peers ai-c jc-sb w-100p">
                                    <div class="p-0 w-100p">
                                        <div class="form-group peers jc-c pX-10 mB-10  w-100p row">
                                            <div class="mB-30 form-row col-xs-7  min-w">

                                                <div class="form-group col-md-7">
                                                    <label for="inputName">Nome</label>
                                                    <input value={this.state.name} style={this.state.name_error ? {borderColor:"red"} : {}} id="name" onChange={this.onChange} class="form-control" name="inputName" placeholder="Nome do paciente"
                                                        required="" type="text"/>
                                                </div>

                                                <div class="form-group col-md-5">
                                                    <label for="inputSecretaryDocument">CPF</label>
                                                    <CpfInput value={this.state.cpf} style={this.state.cpf_error ? {borderColor:"red"} : {}} id="cpf" onChange={this.onChange} class="form-control" name="inputSecretaryDocument"
                                                        placeholder="CPF" type="text"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputEmail">E-mail</label>
                                                    <EmailInput value={this.state.email} style={this.state.email_error ? {borderColor:"red"} : {}} id="email" onChange={this.onChange} class="form-control" name="inputEmail" placeholder="E-mail"
                                                        type="email"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputPhone">Telefone</label>
                                                    <TelephoneInput value={this.state.telephone} style={this.state.telephone_error ? {borderColor:"red"} : {}} id="telephone" onChange={this.onChange} class="form-control" name="inputPhone" placeholder="Telefone"
                                                        type="text"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputPhone2">Telefone Resp.</label>
                                                    <TelephoneInput value={this.state.res_telephone} id="res_telephone" onChange={this.onChange} class="form-control" name="inputPhone2" placeholder="Telefone"
                                                        required="" type="text"/>
                                                </div>
                                                <br/>
                                                <div className="form-group col-md-12">
                                                    <hr/>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div class="form-group col-md-2">
                                                    <label for="inputCEP">CEP</label>
                                                    <CepInput value={this.state.cep}  style={this.state.cep_error ? {borderColor:"red"} : {}} id="cep" onChange={this.onChange} class="form-control" name="inputCEP" placeholder="CEP"
                                                        required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputStreet">Rua</label>
                                                    <input value={this.state.street} id="street" style={this.state.street_error ? {borderColor:"red"} : {}} onChange={this.onChange} class="form-control" name="inputStreet" placeholder="Rua"
                                                        required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-2">
                                                    <label for="inputNumber">Número</label>
                                                    <input value={this.state.number} id="number" style={this.state.number_error ? {borderColor:"red"} : {}} onChange={this.onChange} class="form-control" name="inputNumber" placeholder="Numero"
                                                        required="" type="number"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputComplement">Complemento</label>
                                                    <input value={this.state.complement} id="complement" onChange={this.onChange} class="form-control" name="inputComplement" placeholder="Complemento"
                                                        required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-5">
                                                    <label for="inputNeighborhood">Bairro</label>
                                                    <input value={this.state.neighborhood} style={this.state.neighborhood_error ? {borderColor:"red"} : {}} id="neighborhood" onChange={this.onChange} class="form-control" name="inputNeighborhood"
                                                        placeholder="Bairro" required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="inputCity">Cidade</label>
                                                    <input value={this.state.city} style={this.state.city_error ? {borderColor:"red"} : {}} id="city" onChange={this.onChange} class="form-control" name="inputCity"
                                                        placeholder="Cidade" required="" type="text"/>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label for="inputState">UF</label>
                                                    <input value={this.state.state} style={this.state.state_error ? {borderColor:"red"} : {}} id="state" onChange={this.onChange} class="form-control" name="inputState"
                                                        placeholder="Estado" required="" type="text"/>
                                                </div>
                                                <br/>
                                                <div className="form-group col-md-12">
                                                    <hr/>
                                                </div>
                                                <div class="form-group col-md-5">
                                                    <label for="inputState">Qual médico?</label>
                                                    <select style={this.state.doctorId_error ? {borderColor:"red"} : {}} id="doctorId" value={this.state.doctorId} onChange={this.onChange} class="form-control">
                                                        <option value={-1} selected="selected">Qual médico?</option>
                                                        {this.props.doctors}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xs-7 col-md-3">
                                                <div class="peers jc-sb">
                                                    <div class="form-group pX-10 mB-10 col-sm-12 w-100p">
                                                        <div onClick={() => this.setState({credit_card:true})} class="radio radio-client-default">
                                                            <input checked={this.state.credit_card} type="radio" name="forma" id="radio-1" value="cartao-credito"/>
                                                            <label for="radio-1">Cadastrar Cartão</label>
                                                        </div>
                                                        <div onClick={() => this.setState({credit_card:false})} class="radio radio-client-default">
                                                            <input checked={!this.state.credit_card} type="radio" name="forma" id="radio-2" value="cartao-debito"/>
                                                            <label for="radio-2">Pagar na Consulta</label>
                                                        </div>
                                                    </div>
                                                    { this.state.credit_card?
                                                    <div class="col-md-12 m-0 p-0 w-100p">
                                                        <div class="col-md-12 mB-10">
                                                            <label for="inputCreditCardNumber">Numero do cartão</label>
                                                            <input value={this.state.credit_card_number} maxLength="19" class="form-control" onChange={this.onChange} id="credit_card_number" placeholder="Número do cartão" required="" type="text"/>
                                                        </div>
                                                        <div class="col-md-12 mB-10">
                                                            <label for="inputCreditCardName">Nome</label>
                                                            <input value={this.state.credit_card_name} class="form-control" onChange={this.onChange} id="credit_card_name" placeholder="Nome impresso no cartão" required="" type="text"/>
                                                        </div>
                                                        <div class="col-md-6 mB-10">
                                                            <label for="inputCreditCardGoodThru">Vencimento</label>
                                                            <input value={this.state.credit_card_valid_thru} maxLength="5" class="form-control" onChange={this.onChange} id="credit_card_valid_thru" placeholder="99/99" required="" type="text"/>
                                                        </div>
                                                    </div>
                                                    :<div></div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="p-10 peers jc-c bdT" style={{position:"absolute", backgroundColor:"white", bottom:0, width:"100%"}}>
                        <button onClick={this.check} class="open-details btn btn-default" type="button">Marcar consulta</button>
                    </div>
                </div>
            </div>
        )
    }
}

class Appointment extends Component{
    state = {
      hour:6,
      snackbar:false,
      message:"",
      rawDate: new Date(),
      secretary_id: localStorage.getItem('userId'),
      email:"",
      doctorId:-1,
      locale: 0,
      today: new Date(),
      clientModal: false,
      availableFisioterapists: [],
      currentFisioterapist: {},
      currentTime: "1"
    }

    getFisioterapists = () =>{
        this.setState({availableFisioterapists: []})
        let date = this.state.today.getFullYear() + "-" + (this.state.today.getMonth() + 1) + "-" + this.state.today.getDate();
        fetch(server.address + "/fisioterapists/available/" + date,{
            method:"GET"
        }).then(response => response.json().then(data =>{
            let availableFisioterapists = []

            // ACTIVATE IF THERE MUST BE A DEFAULT BLUES OPTION
            //availableFisioterapists.push(<BluesCard activateModal={(time, clinic) => this.setState({clientModal: true, currentFisioterapist: null, currentTime:time, isClinic:clinic})} />)

            // AVAILABLE FISIOTERAPISTS
            Object.keys(data).forEach((fisio) =>{
                console.log(fisio)
                availableFisioterapists.push(<FisioterapistCard 
                                                name={fisio}
                                                fisioterapist={data[fisio].fisioterapist}
                                                time={data[fisio].times}
                                                activateModal={(hourString, isClinic) => 
                                                    this.setState({isClinic: isClinic,currentTime:hourString, clientModal:true,currentFisioterapist:data[fisio].fisioterapist})}/>)
            })

            if(availableFisioterapists.length == 0)
                this.props.alert("Nenhum Fisioterapeuta Disponível","Por favor, selecione outro dia...","warning")

            this.setState({availableFisioterapists: availableFisioterapists});
        }));
    }

    updateState = (event) =>{
        this.setState({[event.target.id]:event.target.value,[event.target.id + "_error"]:false});
    }

    componentWillMount(){

      this.load_employees();
      this.getFisioterapists();
    }

    load_employees= () =>{
        server.get("clinics/" +  server.clinic.id + "/employees", (data) => {
            let content = [];
            data.forEach((data) =>{
                if(data.rank === "doctor"){
                    content.push(<option value={data.id}>{data.id} - {data.name}</option>)
                }
            });
            this.setState({doctors: content});
        })
    }

    changeDate = (i) =>{
        let newDate = this.state.today;
        newDate.setDate(newDate.getDate() + i);
        this.setState({today:newDate}, this.getFisioterapists);
    }

    render(){
        let monthsLabel = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]
        let yesterday = new Date();
        let tomorrow = new Date();
        yesterday.setDate(this.state.today.getDate() - 1);
        tomorrow.setDate(this.state.today.getDate() + 1);

        return(
        <div style={{width:"100%"}}>
        <div class="col1-app">
            <div class="col1-app__wrapper">
                <div class="col1-list h-100p">
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="content-header__left">
                            <div class="content-header__title">
                                <h3 class="m-0">
                                    Agendar
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="p-20 bdB">
                        <div class="col-md-6  peers jc-c">
                            <div class="date-picker">
                                <div class="date-picker__button" onClick={()=>this.changeDate(-1)}>
                                    <div class="c-client-default">
                                        <i class="fa fa-angle-left"></i>
                                    </div>
                                </div>
                                <div style={{cursor:"pointer"}} class="date-picker__before" onClick={()=>this.changeDate(-1)}>
                                    <div class="c-client-secondary">
                                        <div class="date">{yesterday.getDate()}</div>
                                        <div class="label">{monthsLabel[yesterday.getMonth()]}</div>
                                    </div>
                                </div>
                                <div class="date-picker__current">
                                    <div class="c-client-default">
                                        <div class="date">{this.state.today.getDate()}</div>
                                        <div class="label">{monthsLabel[this.state.today.getMonth()]}</div>
                                    </div>
                                </div>
                                <div style={{cursor:"pointer"}} class="date-picker__after" onClick={()=>this.changeDate(1)}>
                                    <div class="c-client-secondary">
                                        <div class="date">{tomorrow.getDate()}</div>
                                        <div class="label">{monthsLabel[tomorrow.getMonth()]}</div>
                                    </div>
                                </div>
                                <div class="date-picker__button" onClick={()=>this.changeDate(1)}>
                                    <div class="c-client-default">
                                        <i class="fa fa-angle-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 p-10">
                            <div class="input-search-area">
                                <input class="w-100p input-muted  bdc-client-secondary bgc-grey-200" type="text" placeholder="Pesquisar por especialidade" />
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>

                    <div class="scrollable p-20 h-100p">
                        <div class="col-md-12">
                            {this.state.availableFisioterapists}
                        </div>
                    </div>
                    <ClientDetails 
                    alert = {this.props.alert}
                    today={this.state.today} 
                    currentTime={this.state.currentTime}
                    currentFisioterapist={this.state.currentFisioterapist}
                    isClinic={this.state.isClinic} 
                    active={this.state.clientModal}
                    doctors={this.state.doctors} 
                    hide={() => this.setState({clientModal:false}, this.getFisioterapists)}/>
                </div>
            </div>
        </div>
        <div class="bcg-overlay open-details"></div>
        </div>
      )
    }
}

export default Appointment



// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleSecretary.js